import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './StatusBar.module.css';

export default function StatusBar({ name, integrations, channelCount, botCount, conversationsToday, botRepliesToday, setupComplete, calendarActivo, reunionesHoy }) {
  const { t } = useTranslation('dashboard');

  const hour = new Date().getHours();
  const greeting = hour < 12
    ? t('statusBar.greeting_morning')
    : hour < 19
      ? t('statusBar.greeting_afternoon')
      : t('statusBar.greeting_evening');

  const statusPills = [
    { label: 'WhatsApp', active: integrations.whatsapp },
    { label: 'Instagram', active: integrations.instagram },
    { label: 'Messenger', active: integrations.messenger },
    { label: 'TikTok', active: integrations.tiktok },
    { label: t('cards.bot.title'), active: botCount > 0 },
  ];

  const metrics = [
    {
      icon: '📱',
      label: t('statusBar.channelsConnected'),
      value: String(channelCount),
    },
    {
      // 🧠 y no 🤖: la etiqueta dice "Asistente IA" y un robot la
      // contradice. ✨ está tomado por InsightsBar para otra cosa.
      icon: '🧠',
      label: t('statusBar.bot'),
      value: botCount > 0 ? t('statusBar.botActive') : t('statusBar.botNone'),
      accent: botCount > 0,
    },
    {
      icon: '💬',
      label: t('statusBar.conversationsToday'),
      value: setupComplete ? String(conversationsToday) : '—',
    },
    {
      icon: '🎯',
      label: t('statusBar.messagesReplied'),
      value: setupComplete ? String(botRepliesToday) : '—',
    },
  ];

  // Reuniones agendadas: sólo con la agenda conectada. La comparación es estricta
  // contra `true` porque `calendarActivo` es tri-estado — `null` mientras algún
  // bot no respondió— y una métrica que aparece a mitad de la carga hace que el
  // dueño vea un número materializarse de la nada.
  //
  // QUÉ CUENTA, para que nadie lo lea mal: reuniones CREADAS HOY que están
  // CONFIRMADAS AHORA. No es "confirmadas hoy". Una creada hoy y cancelada dentro
  // de un rato deja de contar y el número baja — aceptado, porque las
  // cancelaciones medidas ocurrieron todas el mismo día de la creación.
  if (calendarActivo === true) {
    metrics.push({
      icon: '📅',
      label: t('statusBar.meetingsBooked'),
      value: setupComplete ? String(reunionesHoy) : '—',
    });
  }

  return (
    <div className={styles.container} data-connected={setupComplete ? 'true' : undefined}>
      <div className={styles.header}>
        <div className={styles.greetingArea}>
          <div className={styles.greeting}>{greeting} 👋</div>
          <div className={styles.subtitle}>{t('statusBar.systemStatus')}</div>
        </div>
        <div className={styles.pills}>
          {statusPills.map((pill) => {
            // tri-state: undefined = loading (NEUTRAL, never red); true = active; false = inactive.
            const loading = pill.active === undefined;
            const active = pill.active === true;
            return (
              <div
                key={pill.label}
                className={`${styles.pill} ${active ? styles.pillActive : loading ? styles.pillLoading : styles.pillInactive}`}
              >
                <span className={`${styles.dot} ${active ? styles.dotActive : loading ? styles.dotLoading : styles.dotInactive}`} />
                {pill.label} {active ? '✔' : loading ? '…' : '✘'}
              </div>
            );
          })}
        </div>
      </div>

      <div className={styles.metricsGrid}>
        {metrics.map((metric, i) => (
          <div key={i} className={styles.metricCard}>
            <div className={styles.metricLabel}>
              <span className={styles.metricIcon}>{metric.icon}</span>
              <span>{metric.label}</span>
            </div>
            <div
              className={styles.metricValue}
              style={{
                color: metric.accent ? '#22c55e' : metric.value === '—' ? '#cbd5e1' : undefined,
              }}
            >
              {metric.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
